import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName } from 'recompose';
import { find, get } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import {
  formatPrice,
  toDefaultDateTimeFormat,
  toShortestDefaultDateFormat,
  toLongDateFormat,
} from 'helpers/utils';
import {
  injectIntl,
  InvoiceBadge,
  SmartTable,
} from 'components';
import InvoiceDetail from 'routes/Calendar/components/InvoiceDetail';
import { green } from '@material-ui/core/colors';

const styles = theme => ({
  dialog: {
    maxWidth: 'none',
    width: '90%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginLeft: '0px !important',
    },
  },
  title: { padding: 0 },
});

class ContactCardDetail extends Component {
  static propTypes = {
    avatar: PropTypes.node.isRequired,
    // isVendor: PropTypes.bool.isRequired,
    order: PropTypes.shape({
      id: PropTypes.number,
    }).isRequired,
    orderRequesting: PropTypes.bool,
    sortedOrders: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),
    classes: PropTypes.shape({}).isRequired,

    formatMessage: PropTypes.func.isRequired,
    readOrder: PropTypes.func.isRequired,
    updateOrder: PropTypes.func.isRequired,
  };

  static defaultProps = {
    orderRequesting: false,
    sortedOrders: [],
  };

  static contextTypes = {
    currentUser: PropTypes.shape({}),
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
  };

  state = {
    open: false,
    id: null,
  };

  handleClose = () => {
    this.setState({ open: false });
  }

  handleOpen = (id) => {
    // this.readOrder(id);
    this.setState({ open: true, id }, this.readOrder(id));
  };

  readOrder = (id) => {
    const { readOrder } = this.props;
    readOrder(id);
  }

  render() {
    const {
      avatar,
      // isVendor,
      order,
      orderRequesting,
      sortedOrders,
      classes,
      formatMessage,
      updateOrder,
    } = this.props;
    const { id, open } = this.state;
    const info = find(sortedOrders, ['id', id]);
    const fields = [
      {
        colSpan: 2,
        label: formatMessage('Delivery'),
        name: 'deliveryDate',
        render: row => (
          <span
            className="blue"
          >
            {toShortestDefaultDateFormat(row.deliveryDate)}
          </span>),
        title: row => toShortestDefaultDateFormat(row.deliveryDate),
      },
      {
        colSpan: 1,
        label: '',
        name: 'type-badge',
        render: row => (
          <div className="invoice-sub-header">
            <InvoiceBadge type={row.createdAsDraft ? 'AO' : row.type}>
              {row.createdAsDraft ? 'AO' : row.type}
            </InvoiceBadge>
          </div>
        ),
      },
      {
        colSpan: 1,
        label: formatMessage('ID'),
        name: 'id',
        render: row => (<span className="blue id-pane" onClick={() => this.handleOpen(row.id)}>{row.id}</span>),
        title: row => row.id,
      },
      {
        colSpan: 1,
        label: formatMessage('Invoice'),
        name: 'orderNum',
        render: row => <span>#{row.orderNum}</span>,
        title: row => `#${row.orderNum}`,
      },
      {
        colSpan: 1,
        label: formatMessage(order.type !== 'PO' ? 'Amount' : 'Cost'),
        name: 'totalPrice',
        render: row => (
          <span>${formatPrice(row.totalPrice)}</span>),
        title: row => `$  ${formatPrice(row.totalPrice)}`,
      },
      {
        colSpan: 1,
        label: formatMessage('Status'),
        name: 'badge',
        render: row => (
          <div className="invoice-sub-header">
            <div className="first-part">
              {row.createdAsDraft && !row.deliveredAt && !row.isDraft ? (
                <InvoiceBadge
                  type="pending"
                  style={{ color: 'red', backgroundColor: '#eeeeee' }}
                >
                  ${formatPrice(row.pending)}/${formatPrice(row.totalPrice)}
                </InvoiceBadge>
              ) : Boolean(row.orderStatus) && (
                <InvoiceBadge type={row.orderStatus} style={row.orderStatus.toLowerCase() === 'paid' ? { color: '#ffffff', backgroundColor: green[400] } : { color: 'red', backgroundColor: '#eeeeee' }}>
                  {row.orderStatus.toUpperCase()}
                </InvoiceBadge>
              )}
            </div>
          </div>
        ),
        title: 'Type',
      },
    ];

    const actions = [
      <Button
        color="primary"
        key="close"
        onClick={this.handleClose}
        variant="text"
      >
        Cancel
      </Button>,
      <Button
        color="primary"
        key="ok"
        onClick={this.handleClose}
        variant="text"
      >
        OK
      </Button>,
    ];
    const dialogTitle = id && info? (
      <div className="dialog-title">
        <ListItem style={{ pointerEvents: 'none' }}>
          {avatar}
          <ListItemText
            primary={get(info, 'seller.account.profile.companyName')}
            secondary={`${get(info, 'seller.account.email')} ${toLongDateFormat(info.createdAt)}`}
          />
        </ListItem>
      </div>
    ) : '';

    return (
      <div className="invoice-history-table">
        <SmartTable
          fields={fields}
          data={sortedOrders}
          sortableFields={['deliveryDate', 'badge']}
          notMobile
        />
        <Dialog
          classes={{ paper: classes.dialog }}
          onClose={this.handleClose}
          open={open}
          scroll="body"
        >
          <DialogTitle classes={{ root: classes.title }}>{dialogTitle}</DialogTitle>
          <DialogContent className="order-detail-dialog">
            {orderRequesting && (
              <div className="customer-progress">
                <CircularProgress />
              </div>
            )}
            <InvoiceDetail
              editDisabled
              formatMessage={formatMessage}
              order={order}
              readOrder={this.readOrder}
              updateOrder={updateOrder}
            />
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default compose(
  setDisplayName('ContactCardDetail'),
  withStyles(styles),
  injectIntl,
)(ContactCardDetail);
